import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { COLORS, IAnnotationColor, LineType } from '../models/annotation';
import { MouseMode } from '../models/mouse-mode';

/** A service to update the mouse mode */
@Injectable({ providedIn: 'root' })
export class MouseModeService {
    mouseMode$: BehaviorSubject<MouseMode> = new BehaviorSubject( MouseMode.ZOOM_X );
    lineType: LineType = LineType.DASHED;
    selectedColor: IAnnotationColor = COLORS[0];

    /** returns an observable that emits when we update the mouse mode */
    getMouseMode$() {
        return this.mouseMode$.pipe( distinctUntilChanged() );
    }

    /** set the mouse mode */
    setMouseMode( newMode: MouseMode ) {
        this.mouseMode$.next( newMode );
    }

    /** get the configured line draw type */
    getLineType() {
        return this.lineType;
    }

    /** set the configured line draw type */
    setLineType( type: LineType ) {
        this.lineType = type;
    }

    /** get the configured line draw color */
    getAnnotationColor() {
        return this.selectedColor;
    }

    /** set the configured line draw color */
    setAnnotationColor( annotationColor: IAnnotationColor ) {
        this.selectedColor = annotationColor;
    }
}
